import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Plus, Manual, Exit, Tooltip } from '@netbasequid/core'
import { useAppSelector } from 'app/hooks'
import { NavBar } from 'components/wrapper'
import SearchBar from 'pages/dashboard/view/SidePanel/SearchBar'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import DarkModeToggle from 'pages/dashboard/DarkModeToggle'
import LabelList from 'pages/dashboard/view/SidePanel/LabelList'
import { HeapEventPage, heapTrack, HeapEvent } from 'utils/heapUtils'
import ListTable from 'pages/dashboard/home/ListTable'
import CategoryButton from 'pages/dashboard/view/SidePanel/CategoryButton'
import { ReportPill } from 'pages/dashboard/view/SidePanel/FilterPills'
import { selectDashboardInfoCategory } from 'features/dashboardInfo/selectors'
import ScreenSpinner from 'components/share/ScreenSpinner'
import { sendTypedMessage } from 'utils/iframeUtil'
import { useBooleanVariationFromFeatureFlag } from 'hooks/useBooleanVariationFromFeatureFlag'
import { EDIT_REDIRECT_FEATURE_FLAG } from 'app/featureFlags'
import {
  DashboardViewContainer,
  DashboardViewBody,
  ActionsListContainer,
  ActionsListLeft,
  SearchBarContainer,
  ActionsListRight,
  BottomContainer,
  BottomLabelContainer,
  StyledButton,
  Divider,
  ListTableContainer,
  CategoryButtonContainer,
  PillContainer,
  ButtonContainer,
  StyledLink
} from './index.css'
import {
  useExitNewDashboardMode,
  useRetrieveDashboardInfos,
  useRetrievePreRequiredRequests
} from '../view/hooks'

const DashboardHome = () => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()
  const currentCategory = useAppSelector(selectDashboardInfoCategory)
  useRetrieveDashboardInfos(currentCategory)

  const exitNewDashboardMode = useExitNewDashboardMode()
  const { pageConfigStatus } = useRetrievePreRequiredRequests()
  const hasExperimentEditFeature = useBooleanVariationFromFeatureFlag(EDIT_REDIRECT_FEATURE_FLAG)

  if (pageConfigStatus !== 'succeeded') return <ScreenSpinner />

  return (
    <DashboardViewContainer $mode={theme}>
      <div className="nav-header">
        <NavBar />
      </div>
      <DashboardViewBody mode={theme}>
        <ActionsListContainer>
          <ActionsListLeft>
            <Tooltip
              mode={theme}
              content={<span>{t('dashboardHomeTooltip.create')}</span>}
              followCursor={false}
              placement="bottom-start"
              enabled={!hasExperimentEditFeature}
              offset={[0, 0]}>
              <ButtonContainer>
                <StyledButton
                  disabled={!hasExperimentEditFeature}
                  onClick={() =>
                    hasExperimentEditFeature && sendTypedMessage('goToCreateDashboard')
                  }
                  startIcon={<Plus fontSize={16} />}
                  mode={theme}>
                  {t('createDashboard')}
                </StyledButton>
              </ButtonContainer>
            </Tooltip>
            <SearchBarContainer mode={theme}>
              <SearchBar
                placeholder={t('dashboardHomeSearchBarPlaecholder')}
                page={HeapEventPage.DashboardHome}
              />
            </SearchBarContainer>
          </ActionsListLeft>
          <ActionsListRight>
            <DarkModeToggle page={HeapEventPage.DashboardHome} />
            <StyledLink
              href="https://help.quid.com/en/collections/10569611-dashboards"
              target="_blank"
              rel="noreferrer"
              onClick={() => {
                heapTrack(HeapEvent.V4DashboardTutorialClick)
              }}>
              <StyledButton color="secondary" startIcon={<Manual fontSize={16} />} mode={theme}>
                {t('tutorials')}
              </StyledButton>
            </StyledLink>
            <StyledButton
              color="secondary"
              startIcon={<Exit fontSize={16} />}
              mode={theme}
              onClick={() => {
                exitNewDashboardMode()
                heapTrack(HeapEvent.V4ExitNewDashboardClick, { page: HeapEventPage.DashboardHome })
              }}>
              {t('exitNewDashboardMode')}
            </StyledButton>
          </ActionsListRight>
        </ActionsListContainer>
        <BottomContainer mode={theme}>
          <BottomLabelContainer>
            <LabelList page={HeapEventPage.DashboardHome} displayAmount />
          </BottomLabelContainer>
          <Divider mode={theme} />
          <ListTableContainer>
            <CategoryButtonContainer>
              <CategoryButton page={HeapEventPage.DashboardHome} />
            </CategoryButtonContainer>
            <PillContainer>
              <ReportPill page={HeapEventPage.DashboardHome} />
            </PillContainer>
            <ListTable />
          </ListTableContainer>
        </BottomContainer>
      </DashboardViewBody>
    </DashboardViewContainer>
  )
}

export default DashboardHome
